import { isNextServer } from '@/intl-jdi-common-ssr/utils/uaParser';

// 定义需要排除的爬虫UA关键字数组
export const EXCLUDED_UA_KEYWORDS = ['Googlebot', 'bingbot'];

export const isExcludeUa = () => {
  let ua = '';
  if (isNextServer()) {
    const { headers: nextHeaders } = require('next/headers');
    ua = nextHeaders().get('User-Agent') || '';
  } else if (typeof navigator !== 'undefined' && navigator.userAgent) {
    ua = navigator.userAgent || '';
  }
  ua = ua.toLowerCase() || '';
  // 排除掉部分爬虫的ua
  // 检查是否包含任何排除关键字
  if (EXCLUDED_UA_KEYWORDS.some((keyword) => ua.includes(keyword.toLowerCase()))) {
    return true;
  }

  return false;
};
